import { Transition } from "@headlessui/react";
import React, { useState } from "react";
// import Avatar from "../../assets/images/svg/user.svg";
import axios from "axios";
import { useToasts } from "react-toast-notifications";
import SuccessImage from "../../assets/images/svg/thankful.svg";
import { createStoriesApi } from "../../store/actions/storiesActions";
import { triggerError } from "../alerts";
import InputFileGroup from "../elements/InputFileGroup";

const Input = ({ name, value, onChange }) => {
  return (
    <input
      type="text"
      name={name}
      value={value}
      onChange={onChange}
      className="w-full block h-12 px-4 story-form-input"
    />
  );
};

const Step1 = ({ data, handleChange, handleChangeCurrentStep }) => {
  return (
    <div className="">
      <p className="text-sm pb-4">Tell us your name</p>

      <Input name="name" value={data?.name} onChange={handleChange} />

      <p className="text-xs text-gray pt-4">
        Ensure it is same name you registered with
      </p>

      <div className="pt-4 pb-4 text-right">
        <button
          type="button"
          onClick={handleChangeCurrentStep}
          className="py-3 px-10 bg-secondary text-white rounded-lg my-3 text-sm-15 focus:outline-none text-center"
        >
          Next
        </button>
      </div>
    </div>
  );
};

const Step2 = ({
  data,
  handleChange,
  handleChangeCurrentStep,
  handleShowPrevious,
}) => {
  return (
    <div className="-mt-3">
      <button
        onClick={handleShowPrevious}
        className="rounded-full px-4 py-2 text-primary focus:outline-none story-form-back-button mb-4"
      >
        &lt;
      </button>
      <p className="text-sm pb-4">
        What is your current role and where do you work?
      </p>

      <Input
        name="companyRole"
        value={data?.companyRole}
        onChange={handleChange}
      />

      <div className="pt-4 pb-4 text-right">
        <button
          type="button"
          onClick={handleChangeCurrentStep}
          className="py-3 px-10 bg-secondary text-white rounded-lg my-3 text-sm-15 focus:outline-none text-center"
        >
          Next
        </button>
      </div>
    </div>
  );
};

const Step3 = ({
  data,
  handleChange,
  handleChangeCurrentStep,
  handleShowPrevious,
}) => {
  return (
    <div className="-mt-3">
      <button
        onClick={handleShowPrevious}
        className="rounded-full px-4 py-2 text-primary focus:outline-none story-form-back-button mb-4"
      >
        &lt;
      </button>
      <p className="text-sm pb-4">Share your Utiva experience</p>

      <textarea
        rows="6"
        className="w-full block px-4 story-form-input resize-none py-4 text-sm-15"
        onChange={handleChange}
        name="experience"
        value={data?.experience}
      ></textarea>

      <div className="pt-4 pb-4 text-right">
        <button
          type="button"
          onClick={handleChangeCurrentStep}
          className="py-3 px-10 bg-secondary text-white rounded-lg my-3 text-sm-15 focus:outline-none text-center"
        >
          Next
        </button>
      </div>
    </div>
  );
};

const Step4 = ({
  displayImages,
  handleImageChange,
  handleRemoveImage,
  handleSubmit,
  handleShowPrevious,
  error,
  loading,
}) => {
  return (
    <div className="-mt-3">
      <button
        onClick={handleShowPrevious}
        className="rounded-full px-4 py-2 text-primary focus:outline-none story-form-back-button mb-4"
      >
        &lt;
      </button>
      <p className="text-sm pb-4 text-primary font-bold mt-2 mb-2">
        Upload image
      </p>

      <InputFileGroup
        preview={displayImages || ""}
        onDrop={handleImageChange}
        accept=".jpg,.jpeg,.png"
        onDeleteClick={() => handleRemoveImage()}
        marginBottom="mb-0"
      />

      <div className="pt-4 pb-4 text-right">
        <button
          type="button"
          disabled={loading}
          onClick={handleSubmit}
          className="py-3 px-10 bg-secondary text-white rounded-lg my-3 text-sm-15 focus:outline-none text-center"
        >
          {loading ? "Submitting..." : "Submit"}
        </button>

        {error && (
          <p className="text-center text-sm-15 text-red-600">{error}</p>
        )}
      </div>
    </div>
  );
};

const Step5 = ({ responseMessage }) => {
  return (
    <div className="mt-16 mx-auto text-center">
      <img src={SuccessImage} className="mx-auto" alt="Successful" />
      <p className="text-sm-15 lg:text-base pb-4 text-black mt-4 mb-2 w-9/12 lg:w-8/12 mx-auto">
        {responseMessage || "Thank you for submitting your story"}
      </p>
    </div>
  );
};

const StoryFormModal = ({ show, handleModalClose, title, ...props }) => {
  const { addToast } = useToasts();
  const [currentStep, setCurrentStep] = useState(1);
  const [data, setData] = useState({
    name: "",
    companyRole: "",
    experience: "",
    image: "",
    approve: false,
  });

  const handleChange = (e) => {
    setData({
      ...data,
      [e.target.name]: e.target.value,
    });
  };

  const [images, setImages] = useState("");
  const [displayImages, setDisplayImages] = useState("");

  const handleImageChange = (acceptedFiles) => {
    var reader = new FileReader();
    reader.onload = function () {
      setDisplayImages(reader.result);
    };
    setImages(acceptedFiles[0]);
    reader.readAsDataURL(acceptedFiles[0]);
  };

  const handleRemoveImage = (key) => {
    setImages("");
    setDisplayImages("");
  };

  const handleShowPrevious = (val) => {
    setCurrentStep(val);
  };
  const handleChangeCurrentStep = (val) => {
    setCurrentStep(val);
  };

  const [error, setError] = useState("");
  const [responseMessage, setResponseMessage] = useState("");
  const [loading, setLoading] = useState(false);
  const handleSubmit = async () => {
    const { name, companyRole, experience, approve } = data;

    if (!name && !companyRole && !experience && !approve) {
      setError("Please make sure all fields are filled");
    } else if (!images) {
      setError(
        "Kindly upload your picture amd make sure it is less than 5MB in size"
      );
    } else {
      setError("");
      try {
        setLoading(true);

        let payload = {
          name,
          companyRole,
          experience,
          approve,
        };

        if (images) {
          const formData = new FormData();
          formData.append("file", images);
          formData.append("upload_preset", "stories");

          const uploadImageResponse = await axios.post(
            "https://api.cloudinary.com/v1_1/utiva/image/upload",
            formData
          );

          if (uploadImageResponse.data.secure_url) {
            payload["imageUrl"] = uploadImageResponse.data.secure_url;
          }
        }

        const response = await createStoriesApi(payload);
        setResponseMessage(response?.message);
        setCurrentStep(5);
        handleRemoveImage();
        setData({
          name: "",
          companyRole: "",
          experience: "",
          image: "",
          approve: false,
        });
        setLoading(false);
      } catch (error) {
        triggerError(addToast, error);
        setError(error?.message);
        setLoading(false);
      }
    }
  };

  const renderScreen = () => {
    switch (currentStep) {
      case 1:
        return (
          <Step1
            data={data}
            handleChange={handleChange}
            handleChangeCurrentStep={() => handleChangeCurrentStep(2)}
          />
        );
      case 2:
        return (
          <Step2
            data={data}
            handleChange={handleChange}
            handleShowPrevious={() => handleShowPrevious(1)}
            handleChangeCurrentStep={() => handleChangeCurrentStep(3)}
          />
        );
      case 3:
        return (
          <Step3
            data={data}
            handleChange={handleChange}
            handleShowPrevious={() => handleShowPrevious(2)}
            handleChangeCurrentStep={() => handleChangeCurrentStep(4)}
          />
        );
      case 4:
        return (
          <Step4
            displayImages={displayImages}
            handleImageChange={handleImageChange}
            handleRemoveImage={handleRemoveImage}
            handleSubmit={handleSubmit}
            handleShowPrevious={() => handleShowPrevious(3)}
            error={error}
            loading={loading}
          />
        );

      default:
        break;
    }
  };

  return (
    <div className="fixed z-10 inset-0 overflow-y-auto">
      <div className="flex items-center justify-center min-h-screen pt-4 px-4 pb-20 text-center sm:block sm:p-0">
        <Transition
          show={show}
          enter="ease-out duration-300"
          enterFrom="opacity-0"
          enterTo="opacity-100"
          leave="ease-in duration-200"
          leaveFrom="opacity-100"
          leaveTo="opacity-0"
        >
          <div className="fixed inset-0 transition-opacity" aria-hidden="true">
            <div className="absolute inset-0 bg-black opacity-70"></div>
          </div>
        </Transition>

        <span
          className="hidden sm:inline-block sm:align-middle sm:h-screen"
          aria-hidden="true"
        >
          &#8203;
        </span>

        <div
          className="inline-block align-center bg-white rounded-2xl text-left overflow-hidden shadow-xl transform transition-all sm:my-8 sm:align-middle sm:max-w-lg sm:w-full"
          role="dialog"
          aria-modal="true"
          aria-labelledby="modal-headline"
        >
          {currentStep === 5 ? (
            <>
              <Step5 responseMessage={responseMessage} />
              <div className="bg-white px-5 py-1 sm:px-12 sm:py-6">
                <div className="mb-3 w-full relative text-left">
                  <div className="text-center">
                    <button
                      type="button"
                      onClick={handleModalClose}
                      className="py-3 px-4 text-primary my-3 text-sm-15 focus:outline-none text-center"
                    >
                      Close
                    </button>
                  </div>
                </div>
              </div>
            </>
          ) : (
            <>
              {" "}
              <div className="pt-10 pb-8 story-form-modal-header px-8">
                <p className="text-primary font-bold">
                  Write your Utiva Story ✌🏾
                </p>
              </div>
              <div className="relative story-form-progress-bg h-2 w-full">
                <div className="w-1/12 absolute left-0 top-0 bg-primary h-2" />
              </div>
              <div className="bg-white px-5 py-1 sm:px-12 sm:py-6">
                <div className="mb-3 mt-8 w-full relative text-left">
                  {renderScreen()}

                  <div className="text-center">
                    <button
                      type="button"
                      onClick={handleModalClose}
                      className="py-3 px-4 text-primary my-3 text-sm-15 focus:outline-none text-center"
                    >
                      Close
                    </button>
                  </div>
                </div>
              </div>
            </>
          )}
        </div>
      </div>
    </div>
  );
};

export default StoryFormModal;
